import { render, staticRenderFns } from "./ExpansionPanels.vue?vue&type=template&id=add5d330&scoped=true&"
import script from "./ExpansionPanels.vue?vue&type=script&lang=js&"
export * from "./ExpansionPanels.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionPanels.vue?vue&type=style&index=0&id=add5d330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add5d330",
  null
  
)

export default component.exports